module.exports = {"future":"%s rimanenti","past":"%s fa","s":"alcuni secondi fa","ss":"%d secondi fa","m":"un minuto fa","mm":"%d minuti fa","h":"un'ora fa","hh":"%d ore fa","d":"un giorno fa","dd":"%d giorni fa","M":"un mese fa","MM":"%d mesi fa","y":"un anno fa","yy":"%d anni fa"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/moment.it.json
// module id = 670
// module chunks = 1 2